import { Route } from "react-router-dom";
import UniversityList from "@/components/CRM/University/UniversityList";
import AddUniversity from "@/components/CRM/University/AddUniversity";
import UniversityDetails from "@/components/CRM/University/UniversityDetails";

const UniversityRoutes = [
    <Route
        path="crm/university"
        element={<UniversityList />}
        key="university-list"
    />,
    <Route
        path="crm/university/new"
        element={<AddUniversity />}
        key="university-add"
    />,
    <Route
        path="crm/university/:id"
        element={<UniversityDetails />}
        key="university-details"
    />,
];

export default UniversityRoutes;
